import { useMemo } from 'react'
import { useDrop } from 'react-dnd'

function useDroppable ({
  name,
  dragType,
  onDrop,
  disabled
}) {
  return useDrop(useMemo(() => ({
    accept: dragType || name,
    canDrop: () => !disabled,
    drop: (item) => {
      onDrop({
        itemId: item.itemId,
      })

      return {
        droppedOnDroppable: true
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver()
    })
  }), [dragType, disabled, name, onDrop]))
}

export default useDroppable
